import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth.store';
import testType from './modules/testType.store';
import testJob from './modules/testJob.store';

Vue.use(Vuex)

export default new Vuex.Store({
  strict: false, //process.env.NODE_ENV !== 'production',
  modules: {
    auth,
    testType,
    testJob
  }
})
